import { render, staticRenderFns } from "./domainsChecker.vue?vue&type=template&id=a65e7f30&scoped=true"
import script from "./domainsChecker.vue?vue&type=script&lang=js"
export * from "./domainsChecker.vue?vue&type=script&lang=js"
import style0 from "./domainsChecker.vue?vue&type=style&index=0&id=a65e7f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e7f30",
  null
  
)

export default component.exports